export default __webpack_public_path__ + "cd1a8aee8220f4f1381e31446d94e4df.jpg";